export const SVG_PATH_NAMES = [
  "18+",
  "about1",
  "angle-down",
  "arrow-bg-down",
  "avatar",
  "ball",
  "bonus/calendar",
  "bonus/card/card_h5_blue",
  "bonus/card/card_h5_green",
  "bonus/card/card_h5_green1",
  "bonus/card/card_h5_purple",
  "bonus/card/card_h5_red",
  "bonus/card/card_h5_yellow",
  "bonus/card/card_pc_blue",
  "bonus/card/card_pc_green",
  "bonus/card/card_pc_green1",
  "bonus/card/card_pc_purple",
  "bonus/card/card_pc_red",
  "bonus/card/card_pc_yellow",
  "bonus/cheer-up",
  "bonus/gift",
  "bonus/gift2",
  "bonus/glooming1",
  "bonus/glooming2",
  "bonus/glooming3",
  "bonus/redeem",
  "bottom-nav/account",
  "bottom-nav/affiliate",
  "bottom-nav/deposit",
  "bottom-nav/menu",
  "bottom-nav/sport",
  "button-current",
  "casino/checkbox_checked",
  "casino/checkbox_unchecked",
  "casino/p1",
  "casino/p10",
  "casino/p2",
  "casino/p3",
  "casino/p4",
  "casino/p5",
  "casino/p6",
  "casino/p7",
  "casino/p8",
  "casino/p9",
  "casino/polygon",
  "casino/search",
  "casino/users",
  "checked",
  "close",
  "copy2",
  "correct",
  "cross",
  "dollar",
  "double-chevron",
  "download",
  "eighteen_plus",
  "exclamation-mark1",
  "favorite",
  "favorited",
  "general/18+_1",
  "general/18+_2",
  "general/Information",
  "general/Union",
  "general/activity1",
  "general/add_to",
  "general/affiliate",
  "general/afiliado",
  "general/alert",
  "general/angle-down",
  "general/angle-down_2",
  "general/app1",
  "general/app2",
  "general/app_pay",
  "general/apple",
  "general/arrow_click_left",
  "general/arrow_click_right",
  "general/arrow_di_down",
  "general/arrow_di_left",
  "general/arrow_di_right",
  "general/arrow_di_up",
  "general/arrow_down",
  "general/arrow_falling",
  "general/arrow_left",
  "general/arrow_long_left",
  "general/arrow_long_right",
  "general/arrow_right",
  "general/arrow_rising",
  "general/arrow_up",
  "general/bank",
  "general/bank_card",
  "general/bank_card2",
  "general/bets_history",
  "general/bg_service",
  "general/bg_service_2",
  "general/bingo",
  "general/bonus",
  "general/bottom_acting",
  "general/bottom_casino",
  "general/bottom_chat",
  "general/bottom_deposit",
  "general/bottom_home",
  "general/bottom_menu",
  "general/bottom_promotions",
  "general/bottom_sports",
  "general/bottom_user",
  "general/bottom_vip",
  "general/bottom_withdrawal",
  "general/casino",
  "general/casino_all_games",
  "general/casino_baseball",
  "general/casino_basketball",
  "general/casino_big",
  "general/casino_hot",
  "general/casino_live",
  "general/casino_orignals",
  "general/casino_slots",
  "general/casino_socccer",
  "general/casino_tennis",
  "general/championship",
  "general/chat1",
  "general/chat2",
  "general/check",
  "general/checked_arr",
  "general/choose_computer",
  "general/choose_off",
  "general/choose_on",
  "general/clock",
  "general/collect",
  "general/computer",
  "general/copy",
  "general/copy1",
  "general/countdown",
  "general/cross",
  "general/cryptocurrency",
  "general/dashboard",
  "general/date",
  "general/daytime",
  "general/delete",
  "general/deposit_again",
  "general/deposite2",
  "general/details",
  "general/details1",
  "general/details2",
  "general/details3",
  "general/doubt1",
  "general/doubt2",
  "general/doubt3",
  "general/edit",
  "general/error",
  "general/exclusion",
  "general/eye-1",
  "general/eye",
  "general/feedback",
  "general/free_bet",
  "general/game_money",
  "general/globe",
  "general/google",
  "general/google_pay",
  "general/google_play",
  "general/google_safe",
  "general/gth",
  "general/history",
  "general/home_football",
  "general/home_game",
  "general/home_hot",
  "general/home_poker",
  "general/home_solt",
  "general/home_trophies",
  "general/hot",
  "general/id_cpf",
  "general/invitation",
  "general/invite",
  "general/label_cham",
  "general/label_hot",
  "general/label_new",
  "general/label_top",
  "general/language",
  "general/like",
  "general/linear_data",
  "general/linear_full_movie",
  "general/linear_full_screen",
  "general/linear_out_movie",
  "general/linear_out_screen",
  "general/linear_share",
  "general/lock",
  "general/lock2",
  "general/longarrow-left",
  "general/longarrow-right",
  "general/lottery",
  "general/love_not",
  "general/love_yes",
  "general/luckymoney",
  "general/mail",
  "general/menu_close",
  "general/menu_open",
  "general/message",
  "general/my_rewards",
  "general/night",
  "general/notify1",
  "general/notify2",
  "general/notify3",
  "general/notify4",
  "general/pas",
  "general/pass",
  "general/phone",
  "general/phone_1",
  "general/placeholder",
  "general/play",
  "general/play1",
  "general/play2",
  "general/points",
  "general/promotions",
  "general/question-mark",
  "general/reemCode",
  "general/refresh",
  "general/right",
  "general/rollover",
  "general/rule",
  "general/rules",
  "general/safe",
  "general/safe2",
  "general/search",
  "general/service",
  "general/service2",
  "general/settings",
  "general/share-1",
  "general/share",
  "general/sign_out",
  "general/sponsor",
  "general/sports",
  "general/sports_big",
  "general/sticky",
  "general/theme",
  "general/time",
  "general/tips_correct",
  "general/tips_error",
  "general/tips_warning",
  "general/top_message",
  "general/tournament",
  "general/transaction",
  "general/unlock",
  "general/unlocked",
  "general/user",
  "general/user_1",
  "general/vip",
  "general/visa",
  "general/wallet",
  "general/wallet_arrow_right",
  "general/warn",
  "general/warning",
  "general/win_casual",
  "general/win_default",
  "general/win_game",
  "general/win_live",
  "general/win_lottery",
  "general/win_shows",
  "general/win_slot",
  "general/win_sport",
  "general/withdraw",
  "general/xx1",
  "general/xx2",
  "general/xx2_activity",
  "general/xx3_activity",
  "general/integral",
  "global-search/all",
  "global-search/baseball",
  "global-search/basketball",
  "global-search/live",
  "global-search/lottery",
  "global-search/original",
  "global-search/show",
  "global-search/slots",
  "global-search/soccer",
  "global-search/special",
  "global-search/sport_live",
  "global-search/tennis",
  "global-search/volleyball",
  "gth",
  "hot",
  "install_browser",
  "install_more",
  "installarrow",
  "is_checked",
  "lock",
  "mdi_biscuit",
  "menu/affiliate",
  "menu/bonus",
  "menu/globe",
  "menu/headphones",
  "menu/notification",
  "menu/points",
  "menu/promotions",
  "menu/question",
  "menu/tournament",
  "menu/users",
  "menu/vip_club",
  "money/cryp_ARB",
  "money/cryp_BNB",
  "money/cryp_BTC",
  "money/cryp_CRO",
  "money/cryp_DAI",
  "money/cryp_DOGE",
  "money/cryp_ETH",
  "money/cryp_LINK",
  "money/cryp_LTC",
  "money/cryp_MATIC",
  "money/cryp_OP",
  "money/cryp_QCoin",
  "money/cryp_SAND",
  "money/cryp_SHIB",
  "money/cryp_TRX",
  "money/cryp_UNI2",
  "money/cryp_USDC",
  "money/cryp_USDT",
  "money/cryp_WBTC",
  "money/cryp_WETH",
  "money/fiat_BRL",
  "pg",
  "play",
  "plus",
  "question_fill",
  "question_mark",
  "refresh",
  "responsible/bet-limit",
  "responsible/deposit",
  "responsible/exclusion",
  "responsible/loss-limit",
  "responsible/shield",
  "responsible/suspend",
  "right_arrow_double",
  "search",
  "share",
  "share1",
  "sigap_log",
  "sociality/c_bluesky",
  "sociality/c_discord",
  "sociality/c_facebook",
  "sociality/c_google",
  "sociality/c_instagra",
  "sociality/c_steam",
  "sociality/c_technology",
  "sociality/c_telegram",
  "sociality/c_threads",
  "sociality/c_tiktok",
  "sociality/c_twitch",
  "sociality/c_whatsapp",
  "sociality/c_x",
  "sociality/c_youtube",
  "sociality/w_facebook",
  "sociality/w_google",
  "sociality/w_instagra1",
  "sociality/w_instagra2",
  "sociality/w_pinterest-1",
  "sociality/w_pinterest",
  "sociality/w_steam",
  "sociality/w_telegram",
  "sociality/w_tiktok",
  "sociality/w_whatsapp",
  "sociality/w_x",
  "sociality/y_facebook",
  "sociality/y_google",
  "sociality/y_instagram",
  "sociality/y_telegram",
  "sociality/y_tiktok",
  "sociality/y_twitter",
  "sports/League",
  "sports/baseball",
  "sports/basketball",
  "sports/betby/baseball",
  "sports/betby/basketball",
  "sports/betby/soccer",
  "sports/betby/tennis",
  "sports/betby/volleyball",
  "sports/cs",
  "sports/dota2",
  "sports/fifa",
  "sports/football",
  "sports/new-icon/AmericanFootball",
  "sports/new-icon/Baseball",
  "sports/new-icon/Basketball",
  "sports/new-icon/Boxing",
  "sports/new-icon/Cricket",
  "sports/new-icon/Darts",
  "sports/new-icon/Esports",
  "sports/new-icon/FIFA",
  "sports/new-icon/Golf",
  "sports/new-icon/Hockey",
  "sports/new-icon/MixedMartial Arts",
  "sports/new-icon/RugbyUnion",
  "sports/new-icon/Snooker",
  "sports/new-icon/Soccer",
  "sports/new-icon/TableTennis",
  "sports/new-icon/Tennis",
  "sports/new-icon/Volleyball",
  "sports/slok",
  "sports/tennis",
  "stats",
  "swiper_next",
  "swiper_prev",
  "thumb",
  "time",
  "title-icons/basketball",
  "title-icons/burgermenu",
  "title-icons/cherry",
  "title-icons/crovn",
  "title-icons/fire",
  "title-icons/fire_1",
  "title-icons/game",
  "title-icons/gamepad",
  "title-icons/lightbulb",
  "title-icons/live",
  "title-icons/live_1",
  "title-icons/releases",
  "title-icons/soccer",
  "title-icons/spade",
  "title-icons/sport",
  "title-icons/star",
  "title-icons/tournament",
  "title-icons/trophy",
  "tournament/hourglass",
  "tournament/timer",
  "tournament/title",
  "tournament/trophy",
  "transaction_step1",
  "transaction_step2",
  "transaction_step3",
  "under_arrow",
  "vip/arrows",
  "vip/gift",
  "vip/level-up",
  "vip/levelup-item",
  "vip/levelup",
  "vip/levelup2",
  "vip/lock",
  "vip/rocket-h5",
  "vip/rocket",
  "vip/shinny",
  "vip/star",
  "vip/unlock",
  "vip/unlock2",
  "vip/wallet",
  "xx",
  "xx1",
  "xx3_activity",
] as const;
